import { Component, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UserApi } from '@lkp/parking-sdk';
import { USER_API } from '../../core/providers/api.module';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-reset-password',
    templateUrl: './request-password-reset.component.html',
    styleUrls: ['./request-password-reset.component.scss'],
    standalone: false
})
export class RequestPasswordResetComponent {
  reqSent: boolean = false;
  email: FormControl = new FormControl('', [Validators.required]);

  readonly onDestroy$ = new Subject<void>();

  constructor(
    @Inject(USER_API) readonly userApi: UserApi,
    readonly router: Router
  ) {}

  sendResetRequest() {
    this.userApi
      .requestPasswordResetAdmin({
        passwordResetRequestTransferDTO: {
          email: this.email.value,
        },
      })
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(() => {
        this.reqSent = true;
      });
  }

  toLogin() {
    this.router.navigate(['../home']);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
